module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/logout-29be382e574455dd8ea9cbc7d4334eb2.svg";